module.exports = __webpack_public_path__ + "static/media/sirenetto.3ffc1394.jpeg";